import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import './shophome.css';
import ProductCard from './ProductCard';
import cartIcon from './media/icons/cart.svg';
import MenuButton from './MenuButton';
import { Product } from './types/Product'; 

const ShopHome: React.FC = () => {
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState<number>(0);

  const getCartCount = (): number => {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    return cart.reduce((sum: number, item: { quantity: number }) => sum + item.quantity, 0);
  };

  useEffect(() => {
    setCartCount(getCartCount());
  }, []);

  const products: Product[] = [
    {
      id: 1,
      name: 'New Era 9Forty Diamond Era “Conglomerator&Co” Snapback',
      description: `- Shipping/Handling\n- Taxes\n- Dimensions: One size fits all`,
      price: "$100.00",
      feature: "Preorder",
      images: [
        require('./media/images/conglomeratorco_snapback.JPEG'),
        require('./media/images/conglomeratorco_snapback1.JPEG'),
        require('./media/images/conglomeratorco_snapback2.JPEG'),
        require('./media/images/conglomeratorco_snapback3.JPEG'),
        require('./media/images/conglomeratorco_snapback4.JPEG'),
      ]
    },
    {
      id: 2,
      name: 'Tycoonland\nSticker',
      description: `- Shipping/Handling\n- Taxes\n- Dimensions: 2.9” x 5”`,
      price: "$7.99",
      feature: "Best Seller",
      images: [require('./media/images/tycoon_sticker.JPEG')]
    },
    {
      id: 3,
      name: 'Questgrid Icon\nSticker',
      description: `- Shipping/Handling\n- Taxes\n- Dimensions: 3.4” x 3.5”`,
      price: "$5.00",
      feature: "User's Choice",
      images: [require('./media/images/iconsticker.PNG')]
    },
    {
      id: 4,
      name: 'Stockbroker TycoonLand\nSticker',
      description: `- Shipping/Handling\n- Taxes\n- Dimensions: 4.2” x 4.2”`,
      price: "$7.99",
      feature: "New",
      images: [require('./media/images/stockbrokertycoon_sticker.PNG')]
    },
    {
      id: 5,
      name: 'Questgrid\nSticker',
      description: `- Shipping/Handling\n- Taxes\n- Dimensions: 2” x 4.5”`,
      price: "$5.00",
      feature: "New",
      images: [require('./media/images/questgridsticker.JPEG')]
    }
  ];

  const handleProductClick = (product: Product): void => {
    navigate(`/product/${product.id}`);
  };

  return (
    <div>
      <MenuButton />

      <section className="section2" id="marketplace">
        <div className="shop-header">
          <h2
            className="shop-title"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          >
            Tycoonland Shop
          </h2>

          <div className="cart-icon-wrapper" onClick={() => navigate('/checkout')}>
            <img src={cartIcon} alt="Cart" className="cart-icon" />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </div>
        </div>
      </section>

      <section className="section" id="marketplace">
        <div className="product-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} onClick={handleProductClick} />
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ShopHome;
